const getModelImage = (
  locale: string,
  model: string,
  grade: string,
  color: string,
  format: string,
  fallback: string,
) => {
  if (fallback && fallback !== '') {
    return fallback
  }

  if (format === 'webp') {
    return `https://kong-proxy-aws.toyota-europe.com/${
      locale === 'lexus' ? 'l' : 'c'
    }1-images/resize/ccis/680x680/png/gb/model/${model}/${
      grade ? `grade/${encodeURIComponent(grade)}/` : ''
    }scale-mode/0/padding/100,100,0,0/image-quality/75/day-exterior-03${
      color ? `_${color}` : ''
    }.webp`
  }

  return `https://kong-proxy-aws.toyota-europe.com/${
    locale === 'lexus' ? 'l' : 'c'
  }1-images/resize/ccis/680x680/zip/gb/model/${model}/${
    grade ? `grade/${encodeURIComponent(grade)}/` : ''
  }scale-mode/0/padding/100,100,0,0/image-quality/75/day-exterior-03${
    color ? `_${color}` : ''
  }.png`
}

export default getModelImage
